import validateSSN from './validateSSN';
import validateSIN from './validateSIN';
import validateEmail from './validateEmail';
import validateAgainstMask from './validateAgainstMask';
import validateFromURI from './validateFromURI';

import { dateMask } from 'constants/masks';

export default {
  ssn: validateSSN,
  sin: validateSIN,
  email: validateEmail,
  date: value => validateAgainstMask(dateMask, value),
  fromURI: uri => (validateFromURI(uri) ? uri : null),
};
